import { useNavigate } from 'react-router-dom';
import { auth } from '../../../lib/firebase';

const SellNeatlyUsedSection = () => {
  const navigate = useNavigate();
  const handleSellClick = async () => {
    const user = auth.currentUser;
    if (!user) {
      navigate('/auth/sign-in?next=/seller-dashboard?action=create&type=item');
      return;
    }
    // Always open create modal in seller dashboard without verification gating
    navigate('/seller-dashboard?action=create&type=item');
  };
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Turn Your Neatly Used Items Into Cash
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Got quality items you no longer use? List them on Campus Market and connect with students ready to buy. It’s fast, safe, and easy.
            </p>
            <button
              type="button"
              onClick={handleSellClick}
              className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sell Your Items
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1400&q=80"
              alt="Neatly used student items"
              loading="lazy"
              onError={(e) => { const t = e.currentTarget; t.onerror = null; t.src = '/household_items.jpg'; }}
              className="w-full h-72 md:h-96 object-cover rounded-2xl"
              style={{
                WebkitMaskImage: 'radial-gradient(ellipse at center, black 55%, transparent 100%)',
                maskImage: 'radial-gradient(ellipse at center, black 55%, transparent 100%)',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellNeatlyUsedSection;